// @flow

// TODO remove it
export async function reportException(error: any, info: any) {
  console.error(error, info)
  return
}
